import {
  QUERY_RETRY_BASE_DELAY_MS,
  QUERY_RETRY_LIMIT,
  QUERY_RETRY_MAX_DELAY_MS,
} from '../constants.ts';
import { ApiError } from './http.ts';

// Retry policy for reads. The server answered when there is an ApiError:
// asking again gets the same 404 or 403, so those fail at once. Anything
// else (a dropped connection, a proxy timeout) is worth a couple more tries
// with a growing pause between them.

/** Whether a failed read should be tried again. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  return !(error instanceof ApiError) && failureCount < QUERY_RETRY_LIMIT;
}

/** The pause before retry number `attempt` (counting from 0): doubling, capped. */
export function retryDelay(attempt: number): number {
  return Math.min(QUERY_RETRY_BASE_DELAY_MS * 2 ** attempt, QUERY_RETRY_MAX_DELAY_MS);
}
